/**
 * Question Management Layout (T-CONTENT-005)
 * Parent route that renders child routes (list, add, edit)
 * Auth is handled by parent _layout route
 */

import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/questions")({
  component: QuestionsLayout,
  // No beforeLoad needed - auth is handled by parent _layout route
})

function QuestionsLayout() {
  // Just render child routes (index, add, edit)
  return <Outlet />
}
